export default "__VITE_ASSET__C1pN9gDF__"